import { useConfigurations } from '../../components/shared/useConfigurations';
import { ConfigurationName } from '../../enums/ConfigurationName';

const useStockCountAutoApprovalConfiguration = (): boolean => {
  const { isConfigurationEnabled } = useConfigurations();

  return isConfigurationEnabled(ConfigurationName.StockCountAutoApprovalPerCount);
};

export default useStockCountAutoApprovalConfiguration;
